/* USF file - DO NOT MODIFY THIS FILE. THIS FILE IS REGULARLY CHANGED BY USF APP AND **ANY DIRECT CHANGES WILL BE LOST**. Use our in-app customization if you need to update CSS and JS code. Auto modified at: 7/10/2025 3:33:53 PM*/
!(function () {
    function e(e) {
      return "[object Function]" === Object.prototype.toString.call(e);
    }
    function t(e) {
      return "string" == typeof e || e instanceof String;
    }
    function r(r) {
      var n;
      r = { config: r }.config;
      var s = new XMLHttpRequest(),
        i = r.type || "GET",
        a =
          "GET" === i
            ? (function (r) {
                var n,
                  s,
                  i = r.data;
                if (!i) return r.url;
                if ((e(i) && (i = i()), !t(i))) {
                  var a = [];
                  for (var o in i) a.push(o + "=" + encodeURIComponent(i[o]));
                  i = a.join("&");
                }
                return (
                  (n = r.url),
                  (s = i) ? (n.includes("?") ? n + "&" + s : n + "?" + s) : n
                );
              })(r)
            : r.url;
      s.open(i, a, !0),
        (s.timeout = r.timeout),
        s.setRequestHeader(
          "Content-Type",
          r.contentType || "application/x-www-form-urlencoded"
        );
      var o = r.error,
        l = !1,
        u = !1,
        c = {
          abort: function () {
            (l = !0), (u = !0), s.abort(), r.abort && r.abort.apply(r, [s]);
          },
        };
      (s.onreadystatechange = function () {
        4 == s.readyState &&
          (s.status >= 200 && s.status < 400
            ? r.success &&
              r.success.apply(r, [
                (function (e, t) {
                  switch (e.dataType) {
                    case "json":
                      return JSON.parse(t.responseText);
                    default:
                      return t.responseText;
                  }
                })(r, s),
                {
                  xhr: s,
                  redirected: (function (e, t) {
                    for (var r = 0, n = t.response; r < n.length; ) {
                      var s = n[r++];
                      if ("\t" !== s && " " !== s && "\r" !== s && "\n" !== s)
                        return "<" === s && -1 !== n.indexOf("<html");
                    }
                  })(0, s),
                  config: r,
                },
              ])
            : o &&
              !l &&
              ((l = !0), o.apply(r, [s, s.status, null, { xhr: s, config: r }])));
      }),
        (s.onerror = function (e) {
          o && !l && ((l = !0), o.apply(r, [s, s.status, e]));
        }),
        (s.ontimeout = function (e) {
          o && !l && ((l = !0), o.apply(r, [s, "timeout", e]));
        }),
        (s.onabort = function (e) {
          u || ((l = !0), (u = !0), r.abort && r.abort.apply(r, [s]));
        });
      var f = r.data;
      e(f) && (f = f());
      try {
        s.send(f);
      } catch (n) {
        o && !l && ((l = !0), o.apply(r, [s, s.status, n]));
      }
      return c;
    }
    var n = function () {
      this.list = new Map();
    };
    (n.prototype = {
      add(e, t) {
        if (Array.isArray(e)) return void e.forEach((e) => this.add(e, t));
        const r = this.list.get(e);
        r ? r.push(t) : this.list.set(e, [t]);
      },
      remove(e, t) {
        const r = this.list.get(e);
        r && (t ? r.splice(r.indexOf(t) >>> 0, 1) : this.list.set(e, []));
      },
      raise(e, t, r) {
        if (!window.usf_container && "rerender" === e) return;
        let n = this.list.get(e);
        n &&
          n.slice().map((e) => {
            e(t, r);
          });
      },
    }),
      window.usf || (window.usf = {});
    var s,
      i = usf.settings;
    (usf.components = {}),
      (usf.collectionsByUrlName = {}),
      (usf.EventHub = n),
      (usf.event = s = new n());
    var a,
      o,
      l = i.instantSearch.online,
      u = i.search.online,
      c = function (e) {
        if (((this.list = []), e))
          for (var t = 0; t < e.length; t++) this.push(e[t]);
        var r = this,
          n = !1;
        window.addEventListener("pagehide", function () {
          if (!n && r.list.length) {
            var e = i.analyticsApiUrl;
            if (void 0 !== navigator.sendBeacon) {
              var t = navigator.sendBeacon(
                e,
                JSON.stringify({ events: r.list, time: new Date() })
              );
              n = t;
            } else {
              var s =
                  "events=" +
                  encodeURIComponent(JSON.stringify(r.list)) +
                  "&time=" +
                  new Date().toISOString(),
                a = new XMLHttpRequest();
              a.open("POST", e, !1),
                a.setRequestHeader("Content-Type", "text/plain;charset=UTF-8"),
                a.send(s);
            }
            r.list = [];
          }
        });
      };
    (c.prototype = {
      push(e) {
        "function" == typeof e && (e = e.apply(this)),
          e.length && this[e[0]].apply(this, e.slice(1, e.length)),
          this.list.push(e);
      },
      track(e, t) {
        (t.event = e),
          (t.siteId = i.siteId),
          (t.time = new Date()),
          this.list.push(t);
      },
    }),
      (window._usfaq = new c(window._usfaq));
    var f,
      d,
      h,
      p,
      g,
      m,
      y,
      _ = { List: 0, Box: 1, Swatch: 2 };
    function w(e) {
      if (e && !d) {
        var t = document.createElement("div");
        (t.innerHTML = e),
          usf_container.parentNode.insertBefore(t, usf_container),
          (d = 1),
          T.redirectToOriginalView();
      }
    }
    // 形参t 不是翻页次数，而是表示是否向上翻页(2表示向上翻，其他只都不是，一般为1 或者0)
    function b(e, t, r) {
      var n;
      function l(i) {
        if (r)
          if (f) {
            var o = f;
            (f = i), o();
          } else f = i;
        else
          !(function (i) {
            ne(),
              (a = null),
              (e.loader = !1),
              r || s.raise("sr_dataReceived", e, i.data);
            var o = i.data.redirect;
            o && e.onRedirect(o);
            if (t && e.result && c)
              1 === t
                ? (e.result.items = e.result.items.concat(i.data.items))
                : e.result.items.unshift(...i.data.items);
            else {
              // if (c && q.take > i.data.total + q.itemsPerPage)
              //   return void (q.take = q.itemsPerPage);
              (e.result = {}), Object.assign(e.result, i.data);
            }
            usf.currency = i.data.currency;
            var l = i.data.facets;
            if (((e.hasFacets = l && l.length), e.hasFacets)) {
              for (var u = !1, f = 0; f < l.length; f++) {
                var d = l[f];
                (d.labels.length ||
                  void 0 !== d.min ||
                  (d.navigationCollectionsKeepMain &&
                    d.navigationCollectionsMenu.length)) &&
                  (u = !0),
                  (d.displayMode = _[d.display]);
              }
              u || (e.hasFacets = !1);
            }
            if (!r && usf.store.useFacetsStore) {
              const t = usf.store.useFacetsStore();
              t.hasFacets = e.hasFacets;
            }
            2 === t || (e.itemsLoaded += i.data.items.length);
            var p = i.data.extra;
            if (p) {
              var v = p.collections;
              if (v)
                for (
                  var g = (usf.collectionsByUrlName = {}), f = 0;
                  f < v.length;
                  f++
                ) {
                  var m = v[f];
                  g[m.urlName] = m;
                }
              w(p.message);
            }
            document.body.classList[e.noFacets ? "add" : "remove"](
              "usf-has-no-facets"
            ),
              r ||
                e.$nextTick(() => {
                  s.raise("sr_updated", e, i.data),
                    n && window.addEventListener("load", () => S(n)),
                    !h &&
                      usf._ios &&
                      ((h = 1),
                      window.addEventListener("pageshow", function () {
                        try {
                          var e = sessionStorage.getItem("usfVP");
                          e && S((e = JSON.parse(e)));
                        } catch (e) {}
                      }));
                });
          })((i = JSON.parse(i)));
      }
      var u = i.search.more,
        c = "more" === u || "infinite" === u;
      if (z) {
        try {
          n = sessionStorage.getItem("usfVP");
        } catch (e) {}
        if (n && ((n = JSON.parse(n)), !p && c && n.take !== q.take))
          return (q.take = n.take), void (p = 1);
      }
      // 类似 向上翻页的功能
      if ((e.loader || (e._refreshTime = new Date().getTime()), c && !t)) {
        var d = 0,
          v = q.take,
          g = i.search.itemsPerPage;
          if(!e.itemsLoaded) e.itemsLoaded = 0;
        // v > g && ((d = Math.floor((v - 1) / g) * g)
        // , (e.itemsOffset = d)
        // ),
          // (e.itemsLoaded = d);
          
      }
      // if(!e.itemsOffset) e.itemsOffset = 0;
      // if(!e.itemsLoaded || e.facetFilters) e.itemsLoaded = 0;
      // if('undefined' == typeof t ) t = 1;
      if (
        (r ||
          ((e.loader = 1 === t ? "more" : 2 !== t || "prev"),
          s.raise("sr_updating", e, null)),
        r)
      )
        f = null;
      else if (void 0 !== f) {
        function m() {
          l(f), (f = void 0);
        }
        return void (null === f ? (f = m) : m());
      }
      var y = { q: P(e.term), apiKey: i.siteId },
        C = T.country;
      C && (y.country = C);
      var k = T.locale;
      k && (y.locale = k),
        window._usfGetProductDescription || (y.getProductDescription = 0);
      var E = T.customerTags;
      E && E.length && (y.customerTags = E.join(","));
      var L,
        O = e.facetFilters,
        U = { query: y, filters: O };
      if (
        (T.onSearch(U),
        (O = U.filters) && (y.facetFilters = JSON.stringify(O)),
        c
        ? ((L = 2 === t ? e.itemsOffset : e.itemsLoaded), (v = q.take > 0 && L == 0 ? q.take : e.itemsPerPage))
        : ((L = (e.page - 1) * e.itemsPerPage), (v = q.take > 0 && L == 0 ? q.take :  e.itemsPerPage)),
        (y.skip = L),
        (y.take = v),
        e.sortBy && "r" !== e.sortBy && (y.sort = e.sortBy),
        !e.itemsLoaded && o !== e.term && ((o = e.term), e.term))
      ) {
        var R = e.result;
        _usfaq.track("search", {
          term: e.term,
          isEmpty: R && !R.items.length && !O,
        });
      }
      a && a.abort(),
        (a = usf.utils.send({
          url: i.searchSvcUrl + "search",
          data: y,
          startTime: e._refreshTime,
          success: l,
          error: function (r, n, s) {
            403 !== n
              ? setTimeout(() => {
                  f = void 0;
                  var r = usf.search;
                  (r._refreshTime = e._refreshTime), b(r, t);
                }, 3e3)
              : w(JSON.parse(r.response).meta.description);
          },
        }));
    }
    function S(e) {
      try {
        sessionStorage.removeItem("usfVP");
      } catch (e) {}
      setTimeout(function () {
        var t = usf_container.querySelector(
          '.usf-results [data-usf-pid="' + e.id + '"]'
        );
        if (
          t &&
          !(function (e) {
            const t = e.getBoundingClientRect();
            return (
              t.top >= 0 &&
              t.left >= 0 &&
              t.bottom <=
                (window.innerHeight || document.documentElement.clientHeight) &&
              t.right <=
                (window.innerWidth || document.documentElement.clientWidth)
            );
          })(t)
        ) {
          var r = t.getBoundingClientRect();
          window.scrollBy(0, r.top - e.y);
        }
      }, window._usfScrollDelay || 200);
    }
    function P(e) {
      for (var t = 0; t < e.length && " " === e[t]; ) t++;
      return (
        t > 0 && (e = e.substr(t)), e.toLocaleLowerCase().replace(/[*\?]/g, "")
      );
    }
    usf._refineTerm = P;
    var C = location.pathname.toLowerCase();
    usf.platform = {
      name: "shopify",
      termVar: "q",
      get country() {
        return Shopify.country;
      },
      isCollectionPage:
        -1 !== C.indexOf("/collections/") && -1 === C.indexOf("/products/"),
      get collection() {
        if (m) return m;
        var e = T.collectionWithParams;
        if (e) {
          var t = e.lastIndexOf("/");
          -1 !== t && (e = e.substring(0, t)), (m = e);
        }
        return e;
      },
      set collection(e) {
        m = e;
      },
      get locale() {
        return _usfLocale;
      },
      get baseUrl() {
        return void 0 === g && "/" === (g = _usfRootUrl) && (g = ""), g;
      },
      get collectionWithParams() {
        var e = C,
          t = T.baseUrl;
        if (e.startsWith(t + "/collections/"))
          return decodeURIComponent(e.substring(t.length + 13));
      },
      get tagUrlName() {
        if (void 0 === y) {
          var e = T.collectionWithParams;
          if (e) {
            var t = e.lastIndexOf("/");
            y = -1 !== t ? e.substring(t + 1) : null;
          }
        }
        return y;
      },
      get customerTags() {
        return _usfCustomerTags;
      },
      onSearch(e) {
        if ("vendors" === T.collection) {
          var t = $.get("q");
          t &&
            ((e.query.q = ""),
            e.filters || (e.filters = {}),
            (e.filters._usf_vendor = ["vendor", [t]]));
        }
        var r = _usfCollectionId || "",
          n = T.tagUrlName;
        n && (r += "/" + n),
          (r || T.isCollectionPage) && (e.query.collection = r);
      },
      init() {
        _usfTheme.applied && (i.search.searchResultsUrl = "/search");
      },
      redirectToOriginalView() {
        var e = location.href;
        -1 === e.indexOf("no-usf") &&
          (location = e + (-1 === e.indexOf("?") ? "?" : "&") + "view=no-usf");
      },
    };
    var T = usf.platform;
    const k = "_usf_";
    function E(e) {
      for (var t = e.changed, r = 0; r < t.length; r++) t[r]();
    }
    var L = function (e) {
      (this.canChangeUrl = e), (this.changed = []);
      var t = this;
      (history.pushState = ((e) =>
        function () {
          var r = e.apply(this, arguments);
          return E(t), r;
        })(history.pushState)),
        (history.replaceState = ((e) =>
          function () {
            var r = e.apply(this, arguments);
            return E(t), r;
          })(history.replaceState)),
        window.addEventListener("popstate", () => E(t));
    };
    function O(e) {
      return (e = e.replace(/\+/g, " ")), decodeURIComponent(e);
    }
    var U = function (e) {
      for (
        var t = e ? e.substring(1).split("&") : [], r = [], n = 0;
        n < t.length;
        n++
      ) {
        var s = t[n].split("="),
          i = s[1];
        if (void 0 !== i) {
          var a = i.split(k);
          if (a.length > 1) for (var o = 0; o < a.length; o++) a[o] = O(a[o]);
          else a = O(i);
          r.push([O(s[0]), a]);
        }
      }
      this.entries = r;
    };
    function R(e) {
      if (Array.isArray(e)) {
        for (var t = [], r = 0; r < e.length; r++)
          t.push(encodeURIComponent(e[r]));
        return t.join(k);
      }
      return encodeURIComponent(e);
    }
    (U.prototype = {
      get(e, t) {
        var r = this.entries.find((t) => t[0] === e);
        return r ? r[1] : t;
      },
      append(e, t) {
        this.entries.find((r) => r[0] === e && r[1] === t) ||
          this.entries.push([e, t]);
      },
      set(e, t) {
        var r = this.entries.find((t) => t[0] === e);
        r ? (r[1] = t) : this.entries.push([e, t]);
      },
      toString() {
        var e = this.entries;
        if (!e.length) return "";
        for (var t = [], r = 0; r < e.length; r++) {
          var n = e[r];
          t[r] = encodeURIComponent(n[0]) + "=" + R(n[1]);
        }
        return "?" + t.join("&");
      },
      delete(e, t) {
        for (var r = this.entries.length - 1; r >= 0; r--) {
          var n = this.entries[r];
          x(e, decodeURIComponent(n[0])) &&
            ((t && decodeURIComponent(n[1]) !== t) || this.entries.splice(r, 1));
        }
      },
    }),
      (usf.URLSearchParams = U);
    var I = location.search;
    function F(e, t, r, n) {
      if (!1 !== r) {
        if (n.canChangeUrl) {
          var s = O(location.search) !== O(e);
          return r || s
            ? ((e = location.pathname + e),
              t || !s
                ? history.replaceState({}, "", e)
                : history.pushState({}, "", e),
              !0)
            : void 0;
        }
        e !== I && ((I = e), E(n));
      }
    }
    function x(e, r) {
      return t(e) ? e === r : e.test(r);
    }
    function A(e, t, r) {
      Object.keys(t).forEach((n) => {
        (function (t, r) {
          for (var n = 0; n < e.entries; n++) {
            var s = e.entries[n];
            if (s[0] === t && s[1] === r) return !0;
          }
        })(n, t[n]) || e[r.append ? "append" : "set"](n, t[n]);
      });
    }
    (L.prototype = {
      get(e, t) {
        return new U(this.getSearch()).get(e, t);
      },
      entries() {
        return new U(this.getSearch()).entries;
      },
      snapshot() {
        this._snapshot = this.entries();
      },
      getSearch() {
        return this.canChangeUrl ? location.search : I;
      },
      getChanges() {
        var e = this.entries(),
          t = this._snapshot;
        if (!t) return e;
        var r = [];
        return (
          e.forEach((e) => {
            t.find(
              (t) =>
                t[0] === e[0] && JSON.stringify(t[1]) === JSON.stringify(e[1])
            ) || r.push(e);
          }),
          t.forEach((t) => {
            e.find((e) => e[0] === t[0]) || r.push([t[0]]);
          }),
          r
        );
      },
      update(e, t, r) {
        var n = new U(this.getSearch());
        if ((r || (r = {}), t))
          if (t.length) t.forEach((e) => n.delete(e));
          else
            for (var s = n.entries.length - 1; s >= 0; s--) {
              var i = n.entries[s],
                a = i[0];
              if (t.hasOwnProperty(a)) {
                var o = t[a];
                i[1] === o && n.delete(a, o);
              }
            }
        return e && A(n, e, r), F(n.toString(), r.replace, r.force, this);
      },
      add(e, t) {
        var r = new U(this.getSearch());
        return (
          t || (t = {}), A(r, e, t), F(r.toString(), t.replace, t.force, this)
        );
      },
      remove(e) {
        var r,
          n = new U(this.getSearch()),
          s = arguments.length;
        if (
          (s >= 2 && "object" == typeof (r = arguments[s - 1]) && r && s--,
          2 === s && (l = arguments[1]))
        )
          for (var i = 0; i < n.entries.length; i++) {
            if ((a = n.entries[i])[0] === e && a[1] === l) {
              n.delete(e, l);
              break;
            }
          }
        else if (t(e))
          for (i = 0; i < n.entries.length; i++) {
            if ((a = n.entries[i])[0] === e) {
              n.delete(e);
              break;
            }
          }
        else if (e.length)
          e.forEach((e) => {
            e && (Array.isArray(e) ? n.delete(e[0], e[1]) : n.delete(e));
          });
        else
          for (i = n.entries.length - 1; i >= 0; i--) {
            var a,
              o = (a = n.entries[i])[0];
            if (e.hasOwnProperty(o)) {
              var l = e[o];
              a[1] === l && n.delete(o, l);
            }
          }
        return r || (r = {}), F(n.toString(), r.replace, r.force, this);
      },
    }),
      (usf.Query = L);
    function N() {}
    N.prototype = {
      get term() {
        return $.get(T.termVar, "");
      },
      set term(e) {
        var t = {};
        (t[T.termVar] = e),
          $.update(t, [/uff_.*/, /usf_.*/, "page"], { force: !0 });
      },
      getTermQuery: (e) => T.termVar + "=" + encodeURIComponent(e),
      get page() {
        return parseInt($.get("page")) || 1;
      },
      set page(e) {
        if (e <= 1) $.remove("page");
        else {
          var t = {};
          (t.page = e), $.add(t);
        }
      },
      get take() {
        return parseInt($.get("usf_take")) || i.search.itemsPerPage;
      },
      set take(e) {
        e ? ((v = {}), (v.usf_take = e), $.update(v)) : $.remove("usf_take");
      },
      get itemsPerPage() {
        return (function (e, t) {
          var r = parseInt(e) || t;
          r > t && (r = t);
          return r;
        })($.get("usf_ipp"), i.search.itemsPerPage);
      },
      getPageUrl(e) {
        if (this.p === this.page) return "javascript:void(0)";
        var t = new URL(window.location.href),
          r = t.searchParams;
        return !e || e <= 1 ? r.delete("page") : r.set("page", e), t.toString();
      },
      get facetFilters() {
        for (var e, t = $.entries(), r = {}, n = 0; n < t.length; n++) {
          var s = t[n],
            i = s[0];
          if (i.startsWith("uff_")) {
            var a = "uff_".length,
              o = i.indexOf("_", a),
              l = i.substring(a, o);
            l = parseInt(l, 36);
            var u = i.substr(o + 1),
              c = s[1];
            Array.isArray(c) || (c = [c]), (r[l] = [u, c]), (e = !0);
          }
        }
        return e ? r : null;
      },
      set facetFilters(e) {
        if (Object.keys(e).length) {
          var t,
            r = {};
          for (var n in e) {
            var s = e[n];
            r["uff_" + ((t = n), parseInt(t).toString(36)) + "_" + s[0]] = s[1];
          }
          $.update(r, [/uff_.*/, "page"]);
        } else this.removeAllFacetFilters();
      },
      get view() {
        return $.get("usf_view", "grid");
      },
      set view(e) {
        if (e) {
          var t = {};
          (t.usf_view = e);
          // , $.add(t);
        } else $.remove("usf_view");
      },
      isViewChanged: (e) => 1 !== e.length || "usf_view" !== e[0][0],
      get sort() {
        var e = $.get("usf_sort");
        if (e) return e;
        var t = i.search.sortFields;
        // if (!usf.platform.isCollectionPage) 
        //   return t ? ("/search" === location.pathname ? "bestselling" : t[0]) : "";
        return t ? ("/search" === location.pathname ? "bestselling" : t[0]) : "";
      },
      set sort(e) {
        if (e) {
          var t = {};
          (t.usf_sort = e), $.add(t);
        } else $.remove("usf_sort");
      },
      removeAllFacetFilters() {
        $.remove([/uff_.*/, "page"]);
      },
      addChangedEventListener(e) {
        $.changed.push(e);
      },
    };
    var q = new N();
    usf.queryRewriter = q;
    var M = function (e) {
      if (((this.plugins = []), e))
        for (var t = 0; t < e.length; t++) this.push(e[t]);
    };
    function B(e, t, r, n) {
      var s, i, a;
      if (!n)
        for (i = document.getElementsByTagName("link"), a = 0; a < i.length; a++)
          if (i[a].href.endsWith(e)) return !1;
      return (
        (s = document.createElement("link")).setAttribute("rel", "stylesheet"),
        s.setAttribute("type", "text/css"),
        s.setAttribute("href", e),
        t && (s.onload = t),
        r && (s.onerror = r),
        document.head.appendChild(s),
        !0
      );
    }
    function j(e, t, r, n) {
      var s, i, a;
      if (!n)
        for (
          i = document.getElementsByTagName("script"), a = 0;
          a < i.length;
          a++
        ) {
          var o = i[a].src;
          if (o && o.endsWith(e)) return !1;
        }
      return (
        (s = document.createElement("script")).setAttribute(
          "type",
          "text/javascript"
        ),
        s.setAttribute("src", e),
        (s.async = !0),
        t && (s.onload = t),
        r && (s.onerror = r),
        document.head.appendChild(s),
        !0
      );
    }
    function H(e, t, r, n) {
      for (var s = 0, i = 0, a = 0; a < e.length; a++) {
        var o,
          l = e[a];
        r ? (0, (o = j)) : (o = B),
          o(
            l,
            function () {
              ++s === i && t();
            },
            null,
            n
          ) && i++;
      }
      i === s && t();
    }
    function V(e, t, r, n) {
      if (!e) throw new Error("Element must be set.");
      if (e.length) for (var s = 0; s < e.length; s++) V(e[s], t, r, n);
      else if ((e._r_events || (e._r_events = {}), "string" == typeof t))
        r &&
          (n || (n = {}),
          (function (e, t, r, n) {
            var s,
              i = e._r_events[t];
            i || (e._r_events[t] = i = []);
            (s = function (t) {
              return r.call(e, t);
            }),
              e.addEventListener(t, s, n),
              (i[i.length] = { handler: r, browserHandler: s, options: n });
          })(e, t, r, n));
      else
        for (var i in t) {
          V(e, i, t[i], r);
        }
    }
    function D(e) {
      "loading" === document.readyState
        ? document.addEventListener("DOMContentLoaded", e)
        : e();
    }
    function W(e) {
      Q && ((Q = []), delete Q), s.raise("is_hide", e);
    }
    function J(e, t) {
      ee(function () {
        !(function (e, t) {
          e.value;
          if (usf.platform.collection && e.closest(".usf-sr-inputbox")) return;
          s.raise("is_show", e);
        })(e);
      });
    }
    (M.prototype = {
      push(e) {
        this.plugins.push(e);
      },
      invoke(e, t) {
        return (function e(t, r, n, s) {
          if (!(r >= t.length)) {
            var i = t[r],
              a = i[n];
            if (a) {
              var o = s.slice(0, s.length);
              return (
                o.push(function () {
                  if (r < t.length - 1) return e(t, r + 1, n, s);
                }),
                a.apply(i, o)
              );
            }
            return e(t, r + 1, n, s);
          }
        })(this.plugins, 0, e, t);
      },
      has(e) {
        for (var t = this.plugins, r = 0; r < t.length; r++)
          if (t[r][e]) return !0;
      },
    }),
      (usf.plugins = new M(usf.plugins)); /* Begin plugin code */
    /* End plugin code */
    (usf.utils = {
      on: V,
      off: function (e, t, r) {
        if (e._r_events && t) {
          var n = null,
            s = e._r_events[t] || [];
          if (void 0 !== r) {
            for (var i = 0, a = s.length; i < a; i++)
              if (s[i].handler === r) {
                n = s[i].browserHandler;
                break;
              }
            e.removeEventListener(t, n), s.splice(i, 1);
          } else if ("string" == typeof t) {
            for (i = 0, a = s.length; i < a; i++)
              (n = s[i].browserHandler), e.removeEventListener(t, n);
            delete e._r_events[t];
          } else
            for (var o in t) {
              for (
                r = t[o], i = 0, a = (s = e._r_events[o] || []).length;
                i < a;
                i++
              )
                if (s[i].handler === r) {
                  n = s[i].browserHandler;
                  break;
                }
              e.removeEventListener(o, n), s.splice(i, 1);
            }
        }
      },
      loadJsFile: j,
      loadFiles: H,
      ready: D,
      installSearchInput: Z,
      hideInstantSearch: W,
      loadAndShowInstantSearch: J,
      stopEvent: (e, t) =>
        !!e &&
        (e.preventDefault && e.preventDefault(),
        t || (e.stopPropagation && e.stopPropagation(), (e.cancelBubble = !0)),
        (e.returnValue = !1),
        !1),
      send(e, t) {
        var n = e.startTime || new Date().getTime();
        if (!e._errorModified) {
          var s = 2500,
            i = e.error;
          (e.timeout = s),
            (e._errorModified = 1),
            (e.error = function (r) {
              var a;
              if (new Date().getTime() - n >= s)
                return e.data && e.data.country
                  ? (delete e.data.country,
                    setTimeout(() => usf.utils.send.apply(this, [e, t]), 200),
                    void (s = 1500))
                  : ((e.url = (a = e.url).includes("fallback")
                      ? a
                      : a.replace(/svc-(\d+)-/, "svc-$1-fallback-")),
                    delete e.timeout,
                    setTimeout(() => usf.utils.send.apply(this, [e, t]), 200),
                    void (s = 1500));
              i.apply(this, arguments);
            });
        }
        if (!t) {
          var a = usf.plugins.invoke("send", [e]);
          if (void 0 !== a) return a;
        }
        return r(e);
      },
      onMobileToggleFilters() {
        (usf.app.hasFilters = !0),
          setTimeout(
            () =>
              document
                .querySelector(".usf-sr-filters")
                .classList.toggle(window.USF_ON_CLASSNAME),
            0
          );
      },
    }),
      (usf.fetch = b);
    var z =
      window.performance &&
      window.performance.navigation.type ===
        window.performance.navigation.TYPE_BACK_FORWARD;
    usf.query = new L(i.search.canChangeUrl);
    var G,
      K,
      Q,
      X,
      $ = usf.query;
    function Y(e) {
      e.target._usf_no_popup || J(e.target);
    }
    function Z(e, t) {
      if (e && (l || u)) {
        var r,
          n,
          s,
          a = e.parentNode;
        if (!a.classList.contains("usf-sr-inputbox")) {
          var o = e.cloneNode(!0);
          a.replaceChild(o, e), (e = o);
        }
        for (; "FORM" !== a.tagName; )
          if ((a = a.parentNode) === document.body) {
            a = null;
            break;
          }
        if (
          ((G = T.baseUrl + i.search.searchResultsUrl),
          a &&
            u &&
            ((a.action = G),
            (a.onsubmit = function (t) {
              if (usf.store.useAppStore) {
                usf.store.useAppStore().addRecentlySearches(e.value);
              }
              var r = window.usf_container;
              return (
                location.pathname.includes(G) ||
                (r && e.closest(".usf-sr-inputbox"))
                  ? ((q.term = e.value), r && r.click(), W(e))
                  : (location =
                      G + "?" + T.termVar + "=" + encodeURIComponent(e.value)),
                usf.utils.stopEvent(t)
              );
            })),
          (e._usf_no_popup = t),
          e.setAttribute("autocomplete", "off"),
          l)
        ) {
          var c = {
            input:
              ((r = Y),
              (n = 180),
              function () {
                var e = this,
                  t = arguments;
                s && clearTimeout(s),
                  (s = setTimeout(function () {
                    (s = null), r.apply(e, t);
                  }, n));
              }),
            keydown: function (e) {
              13 === e.keyCode &&
                (usf.utils.stopEvent(e),
                a && u
                  ? a.onsubmit()
                  : (location =
                      G +
                      "?" +
                      T.termVar +
                      "=" +
                      encodeURIComponent(e.target.value)));
            },
            click: t
              ? null
              : function (e) {
                  return J(e.target, window._usfForceIs), usf.utils.stopEvent(e);
                },
          };
          V(e, c);
        }
      }
    }
    function ee(e) {
      if (2 !== K)
        if (1 !== K) {
          var t;
          K = 1;
          var r = [
              (t = _usfTheme.assetUrl.replace("usf-boot.js", "{0}")).replace(
                "{0}",
                "usf.js?v=15"
              ),
            ],
            n = [t.replace("{0}", "usf.css?v=3")];
          s.raise("preinit"),
            e ||
              b(
                {
                  term: q.term,
                  itemsPerPage: q.itemsPerPage,
                  page: q.page,
                  facetFilters: q.facetFilters,
                  sortBy: q.sort,
                },
                0,
                !0
              ),
            H(
              r,
              function () {
                (K = 2),
                  Q && (Q.forEach((e) => e()), delete Q),
                  (G = T.baseUrl + i.search.searchResultsUrl),
                  e && e(),
                  D(function () {
                    s.raise("init");
                  });
              },
              1,
              !0
            ),
            H(n, function () {}, 0, !0);
        } else e && (Q || (Q = []), Q.push(e));
      else e && e();
    }
    if (i.online) {
      /* Begin theme init code */
      usf.event.add('preinit', function () {
            if (!usf.platform.isCollectionPage) {
              var f = usf.settings.search.sortFields[0];
              usf.settings.search.sortFields[0] = 'bestselling';
              (usf.settings.search.sortFields.length > 1) && (
                usf.settings.search.sortFields[1] = f
              )
                // usf.settings.search.sortFields = 'bestselling';
            }
        });
         /* End theme init code */
      T.init();
      var te = location.pathname,
        re = (usf._canLoadContainer =
          (T.isCollectionPage
            ? i.collections.online
            : -1 !== te.indexOf(i.search.searchResultsUrl) && i.search.online) ||
          window._usfHasContainer);
      re
        ? ee()
        : (T.isCollectionPage || te.startsWith(i.search.searchResultsUrl)) &&
          T.redirectToOriginalView(),
        D(function () {
          var e = document.body.classList;
          function t() {
            /* Begin theme ready code */ if (
              usf.settings.instantSearch.online
            ) {
              var searchIcon = document.querySelector(
                '[data-modal-toggle="#search-modal"]'
              );
              if (searchIcon) {
                searchIcon.addEventListener("click", function (e) {
                  // var target = document.createElement("input");
                  var target = document.querySelector('#search-modal [name="q"]');
                  usf.utils.loadAndShowInstantSearch(target, true);
                  // usf.utils.stopEvent(e);
                });
              }
            }
            /* End theme ready code */
            l &&
              i.instantSearch.searchBoxSelector.split(",").forEach((e) => {
                for (
                  var t = document.body.querySelectorAll(e), r = 0;
                  r < t.length;
                  r++
                )
                  Z(t[r]);
              }),
              document.body.addEventListener("keyup", function (e) {
                9 == e.keyCode && document.body.classList.add("usf-wc");
              }),
              document.addEventListener("click", function (e) {
                document.body.classList.remove("usf-wc");
              });
          }
          ne(),
            i.darkMode && e.add("usf-dark"),
            re &&
              window.usf_container &&
              (e.add("usf-has-container"),
              T.isCollectionPage && e.add("usf-collections-page"),
              //ql-modify 暂定都是水平
              e.add(i.filters.horz ? "usf-horz-layout" : "usf-vert-layout"),
              // e.add("usf-horz-layout"),
              e.add("usf-horz-position-" + i.filters.filtersHorzPosition),
              e.add("usf-horz-style-" + i.filters.filtersHorzStyle),
              e.add("usf-mobile-style-" + i.filters.filtersMobileStyle)),
            usf.isMobile ? window.addEventListener("load", t) : t();
        });
    } else T.redirectToOriginalView();
    function ne() {
      X ||
        ((X = 1),
        (usf.isMobile = document.body.clientWidth < i.mobileBreakpoint) &&
          (document.body.classList.add("usf-mobile"),
          (usf.isMobileFilter = !i.filters.desktopLikeMobile)));
    }
  })();
  